import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Renderschool = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();




const [tblblinfo, setTblblinfo] = useState([]);
const [tblschool, setTblschool] = useState([]);
const [tblemployer, setTblemployer] = useState([]);

const [arrayschool, setArrayschool] = useState([]);

const [school, setSchool] = useState({
	SCHOOLID: ""
	, SCHOOLNAME: ""
	,EMPL_ID: ""
	,SCHOOL_COMPANY: ""
});



const [dowait, setDowait] = useState({on:false});

const [crit, setCrit] = useState({
	MPR_FILTER: "school"
	, SECTOR: ""
	});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "Schools";

if (tblschool.length<1){
	gettblschool();
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {

		
 },[JSON.stringify(tblschool)]);



 

useEffect(() => {
		console.log("school: "+JSON.stringify(school));
		if (school.SCHOOLID>0)
			writetblschool(school.SCHOOLID);
		
 },[school.SCHOOLID]);


useEffect(() => {
	 
	 //console.log("tblschool: "+JSON.stringify(tblschool));
		
	
 },[JSON.stringify(tblschool)]);

 

useEffect(() => {
	 
	 gettblschool();
		
	
 },[JSON.stringify(crit)]); 
 
useEffect(() => {
	 
	 if (arrayschool.length>0)
		writetblschool(null);
	else{
		setTblschool([]);
		setTblemployer([]);
		}
		
	
 },[JSON.stringify(arrayschool)]);
 
 
 
 
 
async function getschool(e, SCHOOLID){
	
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {SCHOOLID:SCHOOLID} )
  };		

  await fetch(resturl+'rarwpform/getschool',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetschool(res) )
      .catch(err => console.log(err));	
	
}//end func


async function aftergetschool(res){
}//end func	
	



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;


	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }//end if
	
	
/*
if (show==false && event.target===document.getElementById("checkBoxes")) {
	document.getElementById("checkBoxes").style.display = "none";
	show = true;
	}	//end if

*/	
    
}//end func



async function gettblschool(){

let params = {
	USERNAME: sessionStorage.getItem("USERNAME")??""
	, MPR_FILTER: crit.MPR_FILTER
	, SECTOR: crit.SECTOR
	};

console.log("gettblschool: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblschool([]);
setTblemployer([]);
  await fetch(resturl+'rarwpform/gettblschool',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblschool(res) )
      .catch(err => console.log(err));

}//end func

function aftergettblschool(res){
	
	
if (!res.length){
	console.log("abort aftergettblschool for !res.length)")
	return;
	}
	
console.log('aftergettblschool, res.length: '+res.length);

let arrtemp=[];

res.map((col, index) => {
	let datas={};
	for(var attributename in col){
			const data=col[attributename];
			//console.log('attributename, data: '+attributename+", "+data);
			datas[attributename] = (data==null)?'':data;
		}//end for	

	arrtemp.push(datas);

});
//console.log('arrtemp: '+JSON.stringify(arrtemp));
setArrayschool(arrtemp);

}//end func


function writetblschool(schoolId){
	//console.log('writetblschool: '+JSON.stringify(arrayschool));
let mprhtmrows=[], schoolhtmrows=[];
	
	for (var index=0; index<arrayschool.length; index++){
		const col=arrayschool[index];
		const SCHOOLID=col['SCHOOLID'];
		const trkey='tr_'+index;
		const TBL=col['TBL'];
		
		{/*checked={school.SCHOOLID==col['SCHOOLID']?true:false}*/}
		
		if (TBL=="SCHOOL" && schoolId == null){
			const radioId='rdschool_'+index;
			console.log('radioId: '+radioId);
			const htmrow=<tr key={trkey} >
			<td align='right' >{1+index}</td>
			<td align='left' >{col['SCHOOLID']}</td>
			<td align='left' >{col['SECTOR']}</td>
			<td align='left' >
			<input type="radio" name="rd_schoolid"  value={col['SCHOOLID']} id={radioId} onClick={(e)=>{openschool(e, col);}} /><label htmlFor={radioId} className="hand" >{col['SCHOOLNAME'].substring(0,24)}</label>
			</td>
			<td align='left' >{col['SCHOOL_COMPANY'].substring(0,24)}</td>
			<td align='left' >{col['CONCESSN']}</td>
			</tr>;
			schoolhtmrows.push(htmrow);
			}//end if


		if (TBL=="EMPLOYER"){
			
			const htmrow=<tr key={trkey} >
			<td align='right' >{1+index}</td>
			<td align='left' >{col['EMPL_ID']}</td>
			<td align='left' >
				<a href="#" className="nodecor" onClick={(e)=>{openemployer(e, col['EMPL_ID'], col['COMPANY']);}}>{col['COMPANY'].substring(0,24)}</a>
			</td>
			</tr>;
			mprhtmrows.push(htmrow);
			}//end if


		}//end for

setTblemployer(mprhtmrows);
console.log("after setTblemployer(mprhtmrows).  schoolId "+schoolId);

if (schoolId==null)
	setTblschool(schoolhtmrows);
else{
/*
	const rd_schoolid = document.getElementsByName("rd_schoolid");
	const len = rd_schoolid.length;
	console.log("len "+len);
	for (var i=0; i<len; i++){
		rd_schoolid[i].checked=false;
		if (rd_schoolid[i].value==schoolId){
			console.log("rd_schoolid[i].value: "+rd_schoolid[i].value);
			rd_schoolid[i].checked=true;
			}
			
		}//end for

*/

	}//end else

/*
		<td align='left' >{col['WRK_PMT_RCP_AMT']}</td>
		<td align='center' >{col['WRK_PMT_APP_DATE']}</td>

*/
	
}//end func

function openemployer(e, EMPL_ID, SCHOOL_COMPANY){
	e.preventDefault();
	if (school.SCHOOLID<=0){
		window.alert("choose a school first");
		return;
		}//end if
		
	setSchool((prev)=>{
		return {...prev
		, EMPL_ID: EMPL_ID
		, SCHOOL_COMPANY: SCHOOL_COMPANY
			};
		});
		
	const btnsave=document.getElementById("btnsave");
	if (btnsave.classList.contains("hidden"))
		btnsave.classList.remove("hidden");
		
		
}//end func

function openschool(e, col){
	
	//e.preventDefault();
	//e.target.checked=true;
	console.log("openschool: arrayschool.length"+arrayschool.length);

	setSchool((prev)=>{
		return {
			...prev
			, SCHOOLID: col.SCHOOLID
			, SCHOOLNAME: col.SCHOOLNAME
			, EMPL_ID: col.EMPL_ID
			, SCHOOL_COMPANY: col.SCHOOL_COMPANY
			}
		});

/*
	if (!document.getElementsByName("LBR_CLR_APP_ID")[0].classList.contains("gnsbro"))
		document.getElementsByName("LBR_CLR_APP_ID")[0].classList.add("gnsbro");

*/
	
}//end func




async function updateschoolemployer(e){
	//e.preventDefault();

if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");

if (school.EMPL_ID<=0){
	alert("Failed because no employer was selected");
	return;
	}//end if

let params = school;
params.USERNAME=sessionStorage.getItem("USERNAME");

console.log("updateschool: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwpform/updateschoolemployer',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdateschool(res) )
      .catch(err => console.log(err));
	
}//end func

async function afterupdateschool(res){
	
	console.log("afterupdateschool: "+JSON.stringify(res));
	
	const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
	
	if (UPDATE_COUNT==0)
		window.alert("operation failed.  try again or contact admin");
	else{
		showsnackbar("done!");
		gettblschool();
		setSchool((prev)=>{
			return {
				...prev
				, SCHOOLID: ""
				, SCHOOLNAME: ""
				, EMPL_ID: ""
				, SCHOOL_COMPANY: ""
				}
			});		
		}//end else
		
}//end func
	


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function critChange(e){
	const {name, value} = e.target;
	
	setCrit((prev)=>{
		return {...prev, [name]:value}
		});
}//end func


function handleChange(e){
	const {name, value} = e.target;
	
	setSchool((prev)=>{
		return {...prev, [name]:value}
		});
}//end func

  return (
    <>
	
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Schools</p>	


<table align='center' width="55%" style={{marginTop:"10px", marginBottom:"10px"}} cellSpacing="0" cellPadding="0" >
<tbody>
	<tr>
		<td align='right' >School Id & Name:&nbsp;</td>
		<td align='left' >
			<input name="SCHOOLID" value={school.SCHOOLID} onChange={(e)=>{handleChange(e);}} size="6" readOnly className="gnsbro" />&nbsp;&nbsp;
			<input name="SCHOOLNAME" value={school.SCHOOLNAME} onChange={(e)=>{handleChange(e);}} size="36" readOnly className="gnsbro" />
		</td>
	</tr>
	<tr>
		<td align='right' >Employer Id & Name:&nbsp;</td>
		<td align='left' >
			<input name="EMPL_ID" value={school.EMPL_ID} onChange={(e)=>{handleChange(e);}} size="6" readOnly className="gnsbro" />&nbsp;&nbsp;
			<input name="SCHOOL_COMPANY" value={school.SCHOOL_COMPANY} onChange={(e)=>{handleChange(e);}} size="36" readOnly className="gnsbro" />
		</td>
	</tr>
	<tr>
		<td align='right' >&nbsp;</td>
		<td align='left' >
			<button className="button hidden" id="btnsave" onClick={(e)=>{updateschoolemployer(e);}} >save changes</button>
		</td>
	</tr>	

	
</tbody>
</table>

	
<table align='center' width="95%" style={{marginTop:"10px", marginBottom:"10px"}} cellSpacing="0" cellPadding="0" >
<tbody>
	<tr valign="top">
	<td align='center' >
		<table align='center' className='customers' style={{width:"95%"}} >
		<thead>
		<tr>
			<th>#</th>
			<th>Id</th>
			<th>
				<select name="SECTOR" value={crit.SECTOR} onChange={(e)=>{critChange(e);}} >
				<option value="" >- Sector -</option>
				<option value="Public" >Public</option>
				<option value="Private" >Private</option>
				</select>
			</th>
			<th>School</th>
			<th>Employer Name</th>
			<th>Concession</th>
		</tr>
		</thead>
		<tbody>
			{tblschool}
		</tbody>
		</table>	
	</td>
	<td align='center' >
		<table align='center' className='customers' style={{width:"95%"}} >
		<thead>
		<tr>
			<th>#</th>
			<th>Id</th>
			<th>Employer Name &nbsp;&nbsp;<input name="MPR_FILTER" value={crit.MPR_FILTER} onChange={(e)=>{critChange(e);}} onFocus={(e)=>{e.target.select();}}  /></th>
		</tr>
		</thead>
		<tbody>
			{tblemployer}
		</tbody>
		</table>	
	</td>
	</tr>


</tbody>
</table>
	

	{/*onSubmit={(e)=>{submitform1(e);}}*/}
	


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
		<p style={{color:"brown",fontWeight:"bold"}} >Add New Worker/ Modify Existing Worker {school.SCHOOLID}</p>
		<p style={{color:"brown"}} >Please be certain to spell the name correctly to help find the person</p>
		
		<form id="form1" method="POST"  >
		<table align='center' style={{width:"75%"}} >
		<tbody>
		<tr>
			<td align="right" >Worker's First Name:</td>
			<td align="left" ><input type="text" name="FIRST_NAME" value={school.FIRST_NAME} required placeholder='first name' onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		</tr>

		</tbody>
		</table>
		</form>
	
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default Renderschool;